<template>
	<div>
		<core-tooltip v-if="'anchor' === type" :tooltip="tooltipText" :forceShow="showCopyTooltip" trigger="click">
			<a
				@click.prevent="copyValue"
				@mouseover="showCopyTooltip = true"
				@mouseleave="showCopyTooltip = false"
				href="#"
			>
				{{ value }}
			</a>
		</core-tooltip>
		<div v-else class="input-copy">
			<core-tooltip :tooltip="tooltipText" :forceShow="showCopyTooltip" trigger="click">
				<div
					@click.prevent="copyValue"
					@mouseover="showCopyTooltip = true"
					@mouseleave="showCopyTooltip = false"
					class="input-copy-group"
				>
					<input :value="value" type="text" readonly="readonly" />
					<button @click.prevent="copyValue" type="button" class="outline">
						{{ buttonText }}
					</button>
				</div>

				<slot />
			</core-tooltip>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			required: true,
		},
		buttonText: {
			type: String,
			default: 'Copy',
		},
		toolTipText: {
			type: String,
			default: 'Click to copy.',
		},
		copiedTooltipText: {
			type: String,
			default: 'Copied!',
		},
		type: {
			type: String,
			default: 'input',
		},
	},
	data() {
		return {
			copied: false,
			showCopyTooltip: false,
		};
	},
	computed: {
		tooltipText() {
			return this.copied ? this.copiedTooltipText : this.toolTipText;
		},
	},
	methods: {
		copyValue() {
			this.showCopyTooltip = false;
			this.$copyText(this.value)
				.then(() => (this.copied = true))
				.then(() =>
					setTimeout(() => {
						this.showCopyTooltip = false;
						setTimeout(() => {
							this.copied = false;
						}, 0);
					}, 1000)
				)
				.then(() => (this.showCopyTooltip = true));
		},
	},
};
</script>

<style lang="scss">
.input-copy-group {
	display: flex;
	align-items: flex-start;
	input {
		margin-right: 10px;
		font-family: monospace !important;
		font-size: 0.9em !important;
		line-height: 14px;
		height: 37px;
	}
}
</style>
